<script>
  import NavbarSuccess from "../NavbarSuccess.svelte";
  import { navigate, Link } from "svelte-routing";
  import { onMount } from "svelte";
  import { Button, Input, Spinner, Table } from "sveltestrap";
  import DataSpinner from "../Spinner.svelte";
  import SucessPTO from "../containers/SucessPTOContainer.svelte";
  import axios from "axios";
  import { differenceInDays, addDays, format, isAfter, isBefore } from 'date-fns';

  let startDate = null;
  let endDate = null;
  let notes;
  let listDate = [];
  let listHours = [];
  let timeOffType;
  let difDays;
  let loading = false;
  let sucess = false;
  let hoursFilledUp = false;
  let requestList = null;
  let fetching = false;
  let isStartDateValid = false;
  let isEndDateValid = false;
  $: isFormValid = isStartDateValid && isEndDateValid && hoursFilledUp && isAllHoursValid();

  onMount(() => {
    GetPTOList();
  });

  function DateAndHours() {
    startDate = startDate;

    const dates = [...document.getElementsByName('date[]')];
    listDate = dates.map(e => new Date(e.value));

    const hours = [...document.getElementsByName('hours[]')];
    listHours = hours.map(e => e.valueAsNumber);
  }

  function startDateChanged() {
    const startDateEl = document.querySelector('.input > #startDate');
    const startDateVal = startDateEl.valueAsDate;
    const endDateEl = document.querySelector('.input > #endDate');
    const endDateVal = endDateEl.valueAsDate;

    const startDateContainer = startDateEl.parentElement;
    if (!startDateVal) {
      startDateContainer.classList.add('invalid');
      startDateContainer.querySelector('.error-notification').innerHTML = 'Start date is empty';
      isStartDateValid = false;
      listDate = [];
      return;
    }

    if (isAfter(startDateVal, endDateVal)) {
      startDateContainer.classList.add('invalid');
      startDateContainer.querySelector('.error-notification').innerHTML = 'Start date is after end date';
      isStartDateValid = false;
      listDate = [];
      return;
    }

    startDateContainer.classList.remove('invalid');
    isStartDateValid = true;

    getDifDays();
  }

  function endDateChanged() {
    const startDateEl = document.querySelector('.input > #startDate');
    const startDateVal = startDateEl.valueAsDate;
    const endDateEl = document.querySelector('.input > #endDate');
    const endDateVal = endDateEl.valueAsDate;

    const endDateContainer = endDateEl.parentElement;
    if (!endDateVal) {
      endDateContainer.classList.add('invalid');
      endDateContainer.querySelector('.error-notification').innerHTML = 'End date is empty';
      isEndDateValid = false;
      listDate = [];
      return;
    }

    if (isBefore(endDateVal, startDateVal)) {
      endDateContainer.classList.add('invalid');
      endDateContainer.querySelector('.error-notification').innerHTML = 'End date is before start date';
      isEndDateValid = false;
      listDate = [];
      return;
    }

    endDateContainer.classList.remove('invalid');
    isEndDateValid = true;

    getDifDays();
  }

  function getDifDays() {
    listDate = [];

    const startDate = document.querySelector('#startDate').valueAsDate;
    const endDate = document.querySelector('#endDate').valueAsDate;

    const days = differenceInDays(endDate, startDate);
    const daysIncludingLastDay = days + 1;

    let curDate = startDate;
    for (var i = 0; i < daysIncludingLastDay; i++) {
      listDate.push(new Date(curDate.getTime()));
      curDate = addDays(curDate, 1);
    }
  }

  function submit() {
    DateAndHours();
    loading = true;

    const listDateAsStrings = listDate.map(e => format(e, 'yyyy-MM-dd'));

    var bodyFormData = new FormData();
    bodyFormData.set("StartDate", startDate);
    bodyFormData.set("EndDate", endDate);
    bodyFormData.set("TimeOffType", timeOffType);
    bodyFormData.set("Date", listDateAsStrings);
    bodyFormData.set("Hours", listHours);
    bodyFormData.set("Notes", notes);
    axios({
      method: "post",
      url: "/RequestPTOApi/SendRequest",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then(function(response) {
        loading = false;
        sucess = true;
      })
      .catch(function(response) {
        console.log(response);
      });
  }

  function GetPTOList() {
    fetching = true;
    axios
      .get("/requestPTOapi/GetEmployeePTOs")
      .then(function(res) {
        requestList = res.data.Result;
        fetching = false;
        console.log(res.data);
      })
      .catch(function(err) {
        console.log(err);
      });
  }

  function isAllHoursValid() {
    const hoursInput = [...document.getElementsByName("hours[]")];
    const isAllInputHasValue = hoursInput.map(e => e.value).every(e => +e > 0);
    return isAllInputHasValue;
  }
</script>

<style>
  input {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
  }
  select {
    width: 50%;
    padding: 10px;
    border-radius: 5px;
  }
  .row {
    margin: 15px 0px;
  }
  button {
    padding: 10px 5px;
    border-radius: 5px;
    background-color: #3498db;
    color: white;
  }

  .request-pto-section {
    width: 30%;
    border: 1px solid #ced4da;
    padding-bottom: 20px;
    border-radius: 3px;
    height: 100%;
  }
  .request-pto-list {
    width: 70%;
    overflow: auto;
    padding: 0px 30px;
  }
  .heading {
    font-weight: 400;
    font-size: 17px;
    background: #223646;
    color: #fff;
    padding: 22px 20px;
  }
  .request-pto-section .row {
    display: flex;
    margin-top: 30px;
    padding: 0 33px;
  }
  .request-pto-section input[type="date"],
  .request-pto-section input[type="datetime-local"],
  .request-pto-section input[type="month"],
  .request-pto-section input[type="time"],
  .request-pto-section select {
    margin-top: 10px;
    /* display: block; */
    /* width: 30%; */
    height: calc(3rem + 2px);
    padding: 5px 10px;
    border: 1px solid #ced4da;
    border-radius: 0;
    font-size: 13px;
  }
  .request-pto-section textarea {
    margin-top: 10px;
    /* display: block; */
    /* width: 30%; */
    height: calc(5rem + 2px);
    padding: 5px 10px;
    border: 1px solid #ced4da;
    border-radius: 0;
    font-size: 13px;
  }
  .request-pto-section button {
    border: 0;
    border-radius: 0;
    margin-left: 33px;
  }
  .request-pto-section .input {
    width: 50%;
    padding-right: 10px;
  }

  .request-pto-section .amount-section {
    width: 85%;
    padding: 10px;
    border: 1px solid #ced4da;
    margin: 0 auto;
    font-size: 12px;
  }
  .request-pto-section .amount-section .item {
    display: flex;
    width: 100%;
    margin: 10px 0;
  }
  .request-pto-section .amount-section .item span {
    padding-right: 15px;
    text-align: left;
    padding-top: 30px;
  }
  .request-pto-section .amount-section .item .hrs-input {
    width: 75%;
  }
  .request-pto-section .amount-section .item .hrs-input input {
    height: calc(2.5rem + 2px);
    padding: 5px 10px;
    border: 1px solid #ced4da;
    border-radius: 0;
  }
  .request-row {
    display: flex;
  }
  .res-view-title {
    display: none;
  }

  .input.invalid > .error-notification {
    display: block;
  }

  .input.invalid > input {
    border-color: red;
  }

  .error-notification {
    display: none;
    color: red;
  }

  @media (max-width: 768px) {
    .request-pto-section {
      width: 100%;
    }
    .request-pto-section .amount-section {
      width: 90%;
    }
    .request-row {
      display: unset;
    }
    .request-pto-list {
      width: 100%;
      padding: 0px;
      border: 1px solid #ced4da;
      height: 450px;
      overflow: auto;
      margin-bottom: 30px;
    }
    .res-view-title {
      display: block;
    }
  }
  @media (max-width: 426px) {
    .request-pto-section .amount-section {
      width: 87%;
    }
    .request-pto-section .amount-section .item span {
      width: 30%;
    }
    .request-pto-section .row {
      margin-top: 10px;
      padding: 0 20px;
    }
    .request-pto-section .input,
    .request-pto-section select {
      width: 100%;
    }
    .request-pto-section button {
      margin-left: 20px;
    }
  }
</style>

<NavbarSuccess />
{#if !sucess}
  <div class="timesite-container">
    <div class="request-row">
      {#if fetching}
        <DataSpinner />
      {:else}
        <div class="request-pto-list">
          {#if requestList !== null}
            <Table responsive bordered>
              <thead>
                <tr>
                  <th>Request Status</th>
                  <th>Request Date</th>
                  <th>Employee</th>
                  <th>Timeoff Label</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Total Hours</th>
                  <th>Approver</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                {#each requestList as list}
                  <tr>
                    <td>
                      <span class="res-view-title">Request Status</span>
                      {list.RequestStatus === null ? 'N/A' : list.RequestStatus}
                    </td>
                    <td>
                      <span class="res-view-title">Request Date</span>
                      {list.RequestDate === null ? 'N/A' : list.RequestDate}
                    </td>
                    <td>
                      <span class="res-view-title">Employee</span>
                      {list.EmployeeName}
                    </td>
                    <td>
                      <span class="res-view-title">Timeoff Label</span>
                      {list.TimeOffTypeLabel === null ? 'N/A' : list.TimeOffTypeLabel}
                    </td>
                    <td>
                      <span class="res-view-title">Start Date</span>
                      {list.StartDate === null ? 'N/A' : list.StartDate}
                    </td>
                    <td>
                      <span class="res-view-title">End Date</span>
                      {list.EndDate === null ? 'N/A' : list.EndDate}
                    </td>
                    <td>
                      <span class="res-view-title">Total Hours</span>
                      {list.TotalHours === null ? 'N/A' : list.TotalHours}
                    </td>
                    <td>
                      <span class="res-view-title">Approver</span>
                      {list.ApproverName === null ? 'N/A' : list.ApproverName}
                    </td>
                    <td>
                      <span class="res-view-title">Notes</span>
                      {list.Notes === null ? 'N/A' : list.Notes}
                    </td>
                  </tr>
                {/each}
              </tbody>
            </Table>
          {/if}
        </div>
      {/if}
      <div class="request-pto-section">
        <div class="heading">Request PTO</div>
        <div class="row">
          <div class="input invalid">
            From:
            <input type="date" id="startDate" bind:value={startDate} on:change={startDateChanged} />
            <small class="error-notification">Start date is empty</small>
          </div>
          <div class="input invalid">
            To:
            <input type="date" id="endDate" bind:value={endDate} on:change={endDateChanged} />
            <small class="error-notification">End date is empty</small>
          </div>
        </div>
        <div class="row">
          <div style="width: 100%">Time off type:</div>
          <select bind:value={timeOffType}>
            <option value="100000000">Personal Time Off</option>
            <option value="100000001">Bereavement</option>
            <option value="100000002">Maternity</option>
            <option value="100000003">Paternity</option>
          </select>
        </div>
        {#if startDate !== null && endDate !== null}
          <div class="row amount-section">
            <div style="width: 100%;">Amount:</div>
            {#each listDate as dateItem, i}
              <div class="item">
                <span style="width: 30%;">
                  {format(dateItem, 'EEE MMM dd')}
                  <input type="hidden" value={format(dateItem, 'yyyy-MM-dd')} name="date[]" />
                </span>
                <div style="width: 70%;" class="hrs-input">
                  Hours
                  <br />
                  <input
                    type="number"
                    on:change={() => hoursFilledUp = isAllHoursValid()}
                    name="hours[]" />
                </div>
              </div>
            {/each}
          </div>
        {/if}
        <div class="row">
          Notes
          <br />
          <Input type="textarea" bind:value={notes} />
        </div>
        <br />
        {#if loading}
          <button type="submit" on:click={submit}>
            <Spinner size="sm" />
            Sending
          </button>
        {:else}
          <button
            type="submit"
            on:click={submit}
            style={!isFormValid ? 'cursor: not-allowed; opacity: 0.5' : ''}
            disabled={!isFormValid ? true : false}>
            Send Request
          </button>
        {/if}
      </div>
    </div>
  </div>
{:else}
  <SucessPTO />
{/if}
